let menuItems = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");
 
for (const menuItem of menuItems) {
    menuItem.addEventListener("mouseover", () => {
        menuItem.setAttribute("open", true);
        
       menuItem.addEventListener("mouseleave", () => {
            menuItem.removeAttribute("open");
        });
 
      menuItem.querySelector("ul").addEventListener("mouseleave", () => {
            menuItem.removeAttribute("open");
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth > 749) return; // Mobile only

  const bodyBlocks = document.querySelectorAll(
    "body .rte:not(header .rte):not(footer .rte):not(#shopify-section-template--24338094915900__image_banner .rte)"
  );

  bodyBlocks.forEach(block => {
    if (block.dataset.readMoreProcessed) return;

    const paragraphs = block.querySelectorAll("p");

    if (paragraphs.length > 1) {
      // Hide all paragraphs after the first
      const hiddenParas = [];
      paragraphs.forEach((p, index) => {
        if (index === 0) return;
        p.classList.add("read-more-content");
        hiddenParas.push(p);
      });

      // Create Read More button and insert after first paragraph
      const btn = document.createElement("span");
      btn.className = "read-more-btn";
      btn.textContent = "Read More";
      paragraphs[0].after(btn);

      // Move the button **inside hidden content** when expanded for Read Less
      block.dataset.readMoreProcessed = "true";
    }
  });

  // Toggle hidden paragraphs
  document.addEventListener("click", function(e) {
    if (!e.target.classList.contains("read-more-btn")) return;

    const btn = e.target;
    const block = btn.closest(".rte");
    const hiddenParas = block.querySelectorAll(".read-more-content");

    if (hiddenParas.length === 0) return;

    if (hiddenParas[0].style.display === "block") {
      // Hide hidden paragraphs
      hiddenParas.forEach(p => p.style.display = "none");
      // Move button back after first paragraph
      block.querySelector("p").after(btn);
      btn.textContent = "Read More";
    } else {
      // Show hidden paragraphs
      hiddenParas.forEach(p => p.style.display = "block");
      // Move button after last hidden paragraph
      hiddenParas[hiddenParas.length - 1].after(btn);
      btn.textContent = "Read Less";
    }
  });
});
